import { computed } from 'vue'
import { AiFeature } from '@/generated/graphql'
import { currentOrganization } from '@/app'

const isAiFeatureEnabled = (feature: AiFeature) =>
  currentOrganization.value?.aiFeatures.some((f) => f.feature === feature && f.enabled) ?? false

export default function useAiFeatures() {
  return {
    isAiFeatureEnabled,
    reactiveAnyAiFeature: (...features: AiFeature[]) =>
      computed(() => features.some(isAiFeatureEnabled)),
  }
}
